import makeStyles from "utils/makeStyles";

export default makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: "100%",
    paddingBottom: theme.spacing(3),
  },
  graphContainer: {
    height: 310,
    position: "relative",
  },
  selectHeader: {
    padding: "2rem 1rem 0 1rem",
  },
  // Compact (40px) filter controls, matching the Dashboard
  filterBar: {
    "& .inputDatePicker": { height: 40 },
    "& .inputDatePicker input": {
      height: 40,
      boxSizing: "border-box",
      padding: "0 14px",
    },
    "& .MuiOutlinedInput-root": {
      minHeight: 40,
      height: 40,
      paddingTop: 0,
      paddingBottom: 0,
    },
    "& .MuiAutocomplete-input": {
      paddingTop: "0 !important",
      paddingBottom: "0 !important",
    },
    "& .MuiAutocomplete-root .MuiOutlinedInput-root": {
      flexWrap: "nowrap",
      overflow: "hidden",
    },
    "& .MuiChip-root": { height: 24 },
    // APPLY / EXPORT buttons
    "& .MuiButton-root": {
      height: 40,
      minHeight: 40,
      paddingTop: 0,
      paddingBottom: 0,
    },
    // Search bar: clamp the Paper and its orange icon button to 40 too
    "& .MuiPaper-root": {
      height: 40,
      overflow: "hidden",
    },
    "& .MuiPaper-root .MuiButtonBase-root": {
      height: 40,
      borderRadius: "0 5px 5px 0",
    },
  },
  wrapper: {
    padding: "2rem 1rem",
    backgroundColor: "white",
    borderRadius: "10px",
  },
  noDataMessage: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
  toggleWrapper: {
    display: "inline-flex",
    justifyContent: "end",
  },
  navLogoWrapper: {
    height: 74,
    display: "flex",
    alignItems: "left",
    paddingTop: 3,
    flexDirection: "column",
    border: "none",
    background: "none",
  },
  navLogo: {
    backgroundSize: "contain",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "left",
    height: "70px",
    width: "90%",
  },
  logo: {
    padding: 5,
    width: 180,
    height: 70,
  },
  defaultLogo: {
    width: "100px",
    marginLeft: 25,
  },
  root1: {
    width: "100%",
    display: "inline",
  },
  inputDatePicker: {
    marginBottom: "0",
  },
}));
